import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./image.html";
import { getBooleanAttr } from 'wds/common';
export let ImageVariants = /*#__PURE__*/function (ImageVariants) {
  ImageVariants["Rounded"] = "rounded";
  ImageVariants["Small_Rounded"] = "small_rounded";
  ImageVariants["Circle"] = "circle";
  ImageVariants["Thumbnail"] = "thumbnail";
  ImageVariants["Basic"] = "basic";
  ImageVariants["Banner"] = "banner";
  ImageVariants["Carousel"] = "carousel";
  ImageVariants["Small_Border"] = "small_border";
  return ImageVariants;
}({});
class Image extends LightningElement {
  constructor(...args) {
    super(...args);
    this.src = void 0;
    this.alt = void 0;
    this.variant = ImageVariants.Rounded;
    this.fallback = 'image';
    this.hideLoadingIcon = false;
    this._loadingBorder = true;
    this._error = false;
    this._loaded = false;
    this._isLoading = false;
  }
  handleLoad(event) {
    this._loaded = true;
    this.dispatchEvent(new CustomEvent(event.type, event));
  }
  handleError(event) {
    this._loaded = true;
    this._error = true;
    this.dispatchEvent(new CustomEvent(event.type, event));
  }
  get variansWithBorder() {
    return ![ImageVariants.Basic, ImageVariants.Banner].includes(this.variant);
  }
  set loadingBorder(value) {
    this._loadingBorder = getBooleanAttr(value);
  }
  get loadingBorder() {
    return this._loadingBorder && this.variansWithBorder;
  }
  set isLoading(value) {
    this._isLoading = getBooleanAttr(value);
  }
  get isLoading() {
    return this._isLoading;
  }
  get isNotLoaded() {
    return !this.hideLoadingIcon && (this._isLoading || !this._loaded);
  }
  get className() {
    return this._loaded ? 'container variant--' + this.variant : 'hidden';
  }
  get loadingClass() {
    let borderStyle = '';
    if (this.variant === ImageVariants.Carousel) {
      borderStyle = ' loading loading-background-inverted';
    } else if (this.loadingBorder) {
      borderStyle = ' loading loading-shadow';
    }
    return `loading ${borderStyle}`;
  }
  get iconFill() {
    if (this.loadingBorder && this.variant === ImageVariants.Carousel) {
      return '#FFFFFF';
    }
    return '#ECECEC';
  }
  set width(value) {
    this.template.host.style.setProperty('--ads-image_width', value);
  }
  get width() {
    return this.template.host.style.getPropertyValue('--ads-image_width');
  }
  set height(value) {
    this.template.host.style.setProperty('--ads-image_height', value);
  }
  get height() {
    return this.template.host.style.getPropertyValue('--ads-image_height');
  }
  get renderDefault() {
    return this._error || !this.src;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Image, {
  publicProps: {
    src: {
      config: 0
    },
    alt: {
      config: 0
    },
    variant: {
      config: 0
    },
    fallback: {
      config: 0
    },
    hideLoadingIcon: {
      config: 0
    },
    loadingBorder: {
      config: 3
    },
    isLoading: {
      config: 3
    },
    width: {
      config: 3
    },
    height: {
      config: 3
    }
  },
  track: {
    _isLoading: 1
  },
  fields: ["_loadingBorder", "_error", "_loaded"]
});
const __lwc_component_class_internal = _registerComponent(Image, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;